// src/components/classroom/components/backup/instructorModeScreens/InstructorModeMainScreen.tsx
import React, { useEffect, useMemo, useRef } from "react";
import Trainer from "../Trainer"; // Adjust if path differs
import { useSelector } from "react-redux";
import { RootState } from "store";
import RoomClient from "components/containers/utils/mediaSoup/RoomClient";


interface InstructorModeMainScreenProps {
  roomClient?: RoomClient | null; // Add roomClient to the interface
}
const InstructorModeMainScreen: React.FC<InstructorModeMainScreenProps> = ({
  roomClient,
}) => {
  const { trainer, participants, consumers } = useSelector((state: RootState) => state.live.settings);
  const audioRefs = useRef<{ [email: string]: HTMLAudioElement }>({});

  useEffect(() => {
    roomClient.consumerResumeAllAudio();
  }, [])

  return (
    <div className="relative w-full h-full bg-black overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <Trainer
          name={trainer?.fullname ?? "Trainer"}
          trainerTableName={null}
          videoHeight="70vh"
          instructorMode={true}
        />
      </div>
    </div>
  );
};

export default InstructorModeMainScreen;
